<div 
  v-if="showBreadCrumb"
  :class="[
    'n-pb-3xl n-pt-5xl   n-position-relative n-z-index-1', 
    styles.breadcrumbsWrapper, 
    {'n-bg-primary-sa-flag-25': isHighlighted}
  ]"
>
  <n-container>
    <v-breadcrumbs class="n-p-0" :items="breadcrumbs">
      <template v-slot:divider>
         <n-icon name="arrow-left-01" size="16" />
      </template>

      <template v-slot:item="{ item }">
        <v-skeleton-loader 
          v-if="isUserInfoLoading"
          loading
          type="text"
          width="7%"
        />
        <template v-else>
          <a 
            :aria-label="item.text" 
            v-if="item.external" 
            :href="item.href"
            class="n-color-neutral-700  n-text-decoration-none" 
            :disabled="item.disabled"
          >
            {{item.text}}
          </a>

          <v-breadcrumbs-item 
            v-else 
            :aria-label="item.text"
            :class="['n-color-neutral-700', styles.activeBreadcrumb, {[styles.disabled]: item.disabled}]"
            @click="onClickBreadcrumb(item)" 
            :disabled="item.disabled"
          >
            {{item.text}}
          </v-breadcrumbs-item>
        </template>
      </template>
    </v-breadcrumbs>
  </n-container>
</div>